
import { useEffect, useState } from 'react';
import { supplierStore } from '@/store';
import { debounce } from '@lhb/func';

const { getSelectList } = supplierStore;

function useSupplier(id?: number): any[] {
  const [options, setOptions] = useState<{label: string, value: any}[]>([]);

  const getOptions = async (id: number, supplierName?: string) => {
    const result: any = await getSelectList({ tenantPlaceId: id, supplierName });
    if (!result) {
      return;
    }
    const options = result.map(item => ({ label: item.supplierName, value: item.id }));
    setOptions(options);
  };

  const onSearch = (value) => {
    const newFn = debounce(getOptions, 500);
    newFn(id, value);
  };


  useEffect(() => {
    getOptions(id!);
  }, [id]);

  return [options, onSearch];
}

export default useSupplier;
